import { render } from "./2.LegalContent.vue?vue&type=template&id=4f1b2f72&scoped=true"
import script from "./2.LegalContent.vue?vue&type=script&lang=js"
export * from "./2.LegalContent.vue?vue&type=script&lang=js"

import "./2.LegalContent.vue?vue&type=style&index=0&id=4f1b2f72&lang=css"
import "./2.LegalContent.vue?vue&type=style&index=1&id=4f1b2f72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1b2f72"]])

export default __exports__